import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const footerLinks = {
  categories: categories.map((c) => ({ label: c.name, to: `/category/${c.slug}` })),
  about: [
    { label: '关于我们', to: '/about' },
    { label: '联系我们', to: '/about#contact' },
    { label: '用户口碑', to: '/about#reputation' },
  ],
  legal: [
    { label: '隐私政策', to: '/about' },
    { label: '用户协议', to: '/about' },
    { label: '免责声明', to: '/about' },
  ],
};

const socialLinks = [
  { icon: 'ri-weibo-line', label: '微博', href: '#' },
  { icon: 'ri-wechat-line', label: '微信', href: '#' },
  { icon: 'ri-tiktok-line', label: '抖音', href: '#' },
  { icon: 'ri-live-line', label: 'B站', href: '#' },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-500">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-background-50/20 rounded-lg flex items-center justify-center">
                <span className="text-background-50 font-bold text-xs font-heading">911</span>
              </div>
              <span className="text-background-50 font-heading font-bold text-lg">爆料网</span>
            </div>
            <p className="text-background-50/70 text-sm leading-relaxed mb-5">
              网红黑料、明星塌房、每日吃瓜爆料追踪平台。做最有态度的娱乐资讯，让每一个吃瓜群众第一时间掌握真相。
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-9 h-9 rounded-full bg-background-50/15 flex items-center justify-center text-background-50/80 hover:text-background-50 hover:bg-background-50/25 transition-all cursor-pointer"
                  aria-label={social.label}
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-background-50 font-heading font-semibold text-sm mb-4">
              <a href="/category/wanghong-heiliao" className="hover:text-background-50/80 transition-colors">
                内容分类
              </a>
            </h4>
            <div className="border-t border-background-50/15 mb-4 w-8"></div>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-background-50/65 text-sm hover:text-background-50 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="text-background-50 font-heading font-semibold text-sm mb-4">
              <a href="/about" className="hover:text-background-50/80 transition-colors">
                关于我们
              </a>
            </h4>
            <div className="border-t border-background-50/15 mb-4 w-8"></div>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-background-50/65 text-sm hover:text-background-50 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-background-50 font-heading font-semibold text-sm mb-4">
              法律声明
            </h4>
            <div className="border-t border-background-50/15 mb-4 w-8"></div>
            <ul className="space-y-2.5">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-background-50/65 text-sm hover:text-background-50 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background-50/10">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="text-background-50/50 text-xs order-2 sm:order-1">
            © 2026 911爆料网 版权所有
          </span>
          <div className="flex items-center gap-5 order-1 sm:order-2">
            <Link to="/about" className="text-background-50/50 text-xs hover:text-background-50/80 transition-colors">
              隐私政策
            </Link>
            <Link to="/about" className="text-background-50/50 text-xs hover:text-background-50/80 transition-colors">
              用户协议
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}